"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { updateAppBar, IAppBarConfig } from "@hooks/useWebviewCallback";
import { getWishlistAppbarConfig } from "@utils/appbarConfig";

interface AppBarHeaderProps {
  cityName: string;
  showCitySelector?: boolean;
  appBarConfig?: IAppBarConfig;
}

const AppBarHeader: React.FC<AppBarHeaderProps> = ({
  cityName,
  showCitySelector = true,
  appBarConfig,
}) => {
  const pathname = usePathname();

  useEffect(() => {
    const config =
      appBarConfig || getWishlistAppbarConfig(cityName, pathname);
    updateAppBar(config);
  }, [cityName, appBarConfig, pathname]);

  if (!showCitySelector) return null;

  return null;
};

export default AppBarHeader;
